export const RQ_DASHBOARD_SALARY_API = {
  url: 'api/dashboard/salary',
  method: 'POST',
  auth: true,
};

export const RQ_DASHBOARD_BILLS_API = {
  url: 'api/dashboard/bills',
  method: 'POST',
  auth: true,
};

export const RQ_DASHBOARD_ATTENDANCE_API = {
  url: 'api/dashboard/attendance',
  method: 'POST',
  auth: true,
};

export const RQ_MONTHLY_SALES = {
  url: 'api/dashboard/monthly-sales',
  method: 'POST',
  auth: true,
};
